module.exports = __webpack_public_path__ + "assets/2020b0fb496fa63dc2674d4a51c0fb54.svg";